export default [
  {
    path: '/connect-asp/:key?',
    name: 'connectAspPage',
    component: () => import(/*webpackChunkName:'connect-asp'*/ '@/views/connectASP/index.vue'),
    meta: {},
  },
];
